<app-header></app-header>
<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-12 col-md-6 mb-5">
                <div class="FAQs-content-child">
                    <div class="FAQs-content-child">
                        <div class="etiquette-content-header-container">
                            <h2 class="etiquette-header">Contact Page</h2>
                        </div>
                        <div class="col-sm-6 col-md-4">
                            <div>32 Kloof St</div>
                            <div>Gardens</div>
                            <div>Cape Town</div>
                            <div>South Africa</div>
                            <div>8001</div>
                        </div>
                        <div class="col-12 col-md-4">
                            <h6>Contact Us:</h6>
                            <div>
                                General Enquiries:<br />
                                <a class="text-primary" href="mailto:info@parkupp.co.za">info@parkupp.co.za</a>
                                <br />
                                <br />
                            </div>
                            <div>
                                Johannesburg: (Kwanele)<br />
                                <a class="text-primary" href="tel:+27 71 402 1338">071 402 1338</a>
                                <br />
                                <br />
                            </div>
                            <div>
                                Cape Town and Durban: (Umar)<br />
                                <a class="text-primary" href="tel:+27 71 280 2308">071 280 2308</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="etiquette-content-header-container">
                    <h2 class="etiquette-header">Contact Form</h2>
                    <app-enquiry-form></app-enquiry-form>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
